import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

export const BounceInAnimation =
    trigger('bounceIn', [
        // Enter transition
      transition(':enter', [
          // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate('0.75s 0.7s', keyframes([
            style({ opacity: 0, transform: 'scale3d(.3, .3, .3)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' }),
            style({ opacity: 0, transform: 'scale3d(1.1, 1.1, 1.1)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' }),
            style({ opacity: 0, transform: 'scale3d(.9, .9, .9)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' }),
            style({ opacity: 1, transform: 'scale3d(1.03, 1.03, 1.03)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' }),
            style({ opacity: 1, transform: 'scale3d(.97, .97, .97)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' }),
            style({ opacity: 1, transform: 'scale3d(1, 1, 1)', 'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)' })
        ]))
      ])
    ]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/bounceIn.animation.ts